/* eslint-disable */
import React, { useState } from "react";
import "./styles.scss";
import { Checkbox } from "@mui/material";
import TablePagination from "@mui/material/TablePagination";
import DataTable from "react-data-table-component";
import { PAGE_SIZES } from "../../../constants/const";
import { useDebounce } from "../../../hooks";
import { ReactComponent as BikeLoader } from "../../../images/loader.svg";
import { useStyles } from "../../../utils/styles";
import useFilter from "../../filterHook";
import TablePaginationActionsCustom from "../paginatorActionCustom";
import SearchBlockWithRefreshBtn from "../searchBlockWithRefreshBtn";

const useCustomTable = (
  columns,
  data,
  reloadData,
  addButtonClick,
  filterObject,
  headerTitle,
  isFilterVisible = true,
  isAddVisible = true,
  onDownloadClick = null,
  searchDataOptions = null,
  expandableRowsOptions = null
) => {
  const [localPage, setLocalPage] = useState(0);
  const [localRows, setLocalRows] = useState(10);
  const [sortData, setSortData] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const [searchFilter, setSearchFilter] = useState();

  const resetPagination = () => {
    setPaginationResetToggle(!paginationResetToggle);
  };

  const appleFilter = () => {
    internalApply();
  };

  const {
    filterModalVisible,
    toggleFilter,
    renderGenericFilter,
    filterData,
    removeFilterByIndex,
    internalApply,
  } = useFilter(appleFilter, filterObject);

  const classes = useStyles();

  const CustomMaterialPagination = ({
    rowsPerPage,
    rowCount,
    onChangePage,
    onChangeRowsPerPage,
    currentPage,
  }) => (
    <TablePagination
      component={"div"}
      rowsPerPageOptions={PAGE_SIZES}
      colSpan={3}
      count={rowCount}
      rowsPerPage={rowsPerPage}
      page={currentPage - 1}
      SelectProps={{
        inputProps: { "aria-label": "rows per page" },
        native: true,
      }}
      onPageChange={onChangePage}
      onRowsPerPageChange={({ target }) =>
        onChangeRowsPerPage(Number(target.value))
      }
      ActionsComponent={TablePaginationActionsCustom}
      className={classes.pagination}
    />
  );

  const debouncedSearchTerm = useDebounce(searchValue, 500);

  const changeSearchValue = (e) => {
    setSearchValue(e.target.value);
  };
  const clearSearchValue = () => {
    setSearchValue("");
  };

  const handleSort = async (column, sortDirection) => {
    setSortData({ column, sortDirection });
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLocalRows(newPerPage);
  };
  const handlePageChange = (page) => {
    setLocalPage(page - 1);
  };

  const customTableStyles = {
    headCells: {
      style: {
        backgroundColor: "#f9f9f9",
        paddingLeft: "3px", // override the cell padding for head cells
        paddingRight: "3px",
        height: 80,
        fontSize: 14,
        lineHeight: "14px",
        maxWidth: 100,
      },
    },
    table: {
      style: {
        padding: 10,
        borderWidth: 1,
        minWidth: 750,
      },
    },
    tableWrapper: {
      style: {},
    },
    cells: {
      style: {
        padding: 6,
        wordBreak: "break-word",
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: 400,
        lineHeight: 1.43,
      },
      draggingStyle: {},
    },
  };

  const renderCustomTable = () => {
    const columnsProceed = columns?.map((column) => {
      const key = column?.selector;
      let selector = key;

      if (typeof selector === "string") {
        selector = (row) => row[key];
      }

      return { ...column, selector: selector };
    });

    return (
      <>
        <DataTable
          columns={columnsProceed}
          data={data?.content}
          defaultSortField="title"
          pagination={true}
          paginationServer={true}
          paginationTotalRows={data?.totalElements}
          className={classes.table}
          progressPending={loading}
          sortServer={true}
          onSort={handleSort}
          customStyles={customTableStyles}
          selectableRowsComponent={Checkbox}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          paginationComponent={CustomMaterialPagination}
          progressComponent={<BikeLoader />}
          paginationResetDefaultPage={paginationResetToggle}
          {...(expandableRowsOptions && {
            expandableRows: expandableRowsOptions.enabled,
            expandableRowExpanded: expandableRowsOptions.rowExpanded,
            expandableRowsComponent: expandableRowsOptions.component,
            onRowExpandToggled: expandableRowsOptions.onToggle,
            expandableRowsHideExpander: true,
          })}
        />
        {renderGenericFilter()}
      </>
    );
  };

  const renderHeaderBar = () => (
    <SearchBlockWithRefreshBtn
      title={headerTitle}
      searchValue={searchValue}
      onChange={changeSearchValue}
      clear={clearSearchValue}
      searchDataOptions={searchDataOptions}
      reloadData={reloadData}
      addAction={isAddVisible && addButtonClick}
      downloadCoupon={onDownloadClick}
      removeFilter={isFilterVisible && removeFilterByIndex}
      pressFilter={isFilterVisible && toggleFilter}
      filterProps={isFilterVisible && filterData.length > 0 ? filterData : []}
      searchFilter={searchFilter}
      setSearchFilter={setSearchFilter}
    />
  );

  return {
    renderCustomTable,
    renderHeaderBar,
    localPage,
    localRows,
    sortData,
    debouncedSearchTerm,
    filterData,
    setLoading,
    resetPagination,
    searchFilter,
  };
};

export default useCustomTable;
